import { useMutation, useQueryClient } from "@tanstack/react-query";
import { decideTargetareListaPropunere } from "@/api/endpoints/targetareConfig";
import { queryKeys } from "@/lib/queryClient";

export function useDecideTargetareListaPropunere() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: decideTargetareListaPropunere,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.listaPropuneri(),
      });
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.liste() });
    },
  });
}
